import React from "react";

const BrowserWindows = () => {

  const openNewTab = () => {
    window.open("new-tab-sample.php", "_blank");
  };

  const popupCenter = (url, title, w, h) => {
    const left = window.screen.width / 2 - w / 2;
    const top = window.screen.height / 2 - h / 2;

    window.open(
      url,
      title,
      `width=${w},height=${h},top=${top},left=${left}`
    );
  };

  return (
    <div className="col-md-8 col-lg-8 col-xl-8">
      <h1 className="mb-3 fw-normal border-bottom text-left pb-2 mb-4">
        Browser Windows
      </h1>

      <button
        type="button"
        className="btn btn-primary me-2"
        onClick={openNewTab}
        title="New Tab"
      >
        New Tab
      </button>

      <button
        type="button"
        className="btn btn-primary me-2"
        onClick={() => popupCenter("new-window.php", "xtf", 900, 500)}
      >
        New Window
      </button>

      <button
        type="button"
        className="btn btn-primary"
        onClick={() => popupCenter("new-tab-message.php", "xtf", 900, 500)}
      >
        New Window Message
      </button>
    </div>
  );
};

export default BrowserWindows;